// src/components/LanguageSelection.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LanguageSelection.css';

const LanguageSelection = () => {
  const navigate = useNavigate();

  const selectLanguage = (language) => {
    navigate(`/dictionary?lang=${language}`);
  };

  return (
    <div className="language-selection-container">
      <h1>Select Language</h1>
      <button onClick={() => selectLanguage('en')}>English</button>
      <button onClick={() => selectLanguage('pt')}>Portuguese</button>
    </div>
  );
};

export default LanguageSelection;